import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_TRIALINSTITUTIONCONTRACT_LOAD_BY_TRIAL_INSTITUTION_ID,
    ACTION_TRIALINSTITUTIONCONTRACT_LOAD_BY_ID,
    ACTION_TRIALINSTITUTIONCONTRACT_LOAD_FAILURE,
    ACTION_TRIALINSTITUTIONCONTRACT_LOAD_SUCCESS,

    ACTION_TRIALINSTITUTIONCONTRACT_SAVE,
    ACTION_TRIALINSTITUTIONCONTRACT_SAVE_SUCCESS,
    ACTION_TRIALINSTITUTIONCONTRACT_SAVE_FAILURE,

    ACTION_TRIALINSTITUTIONCONTRACT_VALIDATE,
    ACTION_TRIALINSTITUTIONCONTRACT_VALIDATE_SUCCESS,
    ACTION_TRIALINSTITUTIONCONTRACT_VALIDATE_FAILURE,

    ACTION_TRIALINSTITUTIONCONTRACT_CREATE,
    ACTION_TRIALINSTITUTIONCONTRACT_CREATE_SUCCESS,
    ACTION_TRIALINSTITUTIONCONTRACT_CREATE_FAILURE,

    ACTION_TRIALINSTITUTIONCONTRACT_DELETE,
    ACTION_TRIALINSTITUTIONCONTRACT_DELETE_SUCCESS,
    ACTION_TRIALINSTITUTIONCONTRACT_DELETE_FAILURE,

    ACTION_TRIALINSTITUTIONCONTRACT_CLEAR,
    ACTION_TRIALINSTITUTIONCONTRACT_FILTER,

    TrialInstitutionContractAction
} from '../actions/trialInstitutionContract';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface ITrialInstitutionContractState {
    formData: Dtos.TrialInstitutionContract | Dtos.TrialInstitutionContract[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    validateState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    deleteState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.TrialInstitutionContract[];
    formLength: number;
}

const initialState: ITrialInstitutionContractState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    deleteState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formLength: 0
};


function loading(state: ITrialInstitutionContractState, _isLoading: boolean): ITrialInstitutionContractState {
    const newState: ITrialInstitutionContractState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: ITrialInstitutionContractState,
    formData: Dtos.TrialInstitutionContract | Dtos.TrialInstitutionContract[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionContractState {
    const newState: ITrialInstitutionContractState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function loadFailure(state: ITrialInstitutionContractState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionContractState {
    const newState: ITrialInstitutionContractState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function filter(state: ITrialInstitutionContractState, formFilter: IFormFilter): ITrialInstitutionContractState {

    const items: Dtos.TrialInstitutionContract[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formLength = items ? items.length : 0;

    const formFilteredData = items ? items.filter(p => (p.active == true || formFilter.showInActive) &&
        (
            formFilter.search == "" ||
            p.name.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1
        )) : undefined;

    const newState: ITrialInstitutionContractState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formLength: {
            $set: formLength
        }
    });

    return newState;
}

function clear(state: ITrialInstitutionContractState, propertiesToClear?: string[]): ITrialInstitutionContractState {

    if (!propertiesToClear) {
        const newState: ITrialInstitutionContractState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: ITrialInstitutionContractState, _isSaving: boolean): ITrialInstitutionContractState {
    const newState: ITrialInstitutionContractState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: ITrialInstitutionContractState,
    formData: Dtos.TrialInstitutionContract | Dtos.TrialInstitutionContract[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionContractState {
    const newState: ITrialInstitutionContractState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: ITrialInstitutionContractState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionContractState {
    const newState: ITrialInstitutionContractState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function validating(state: ITrialInstitutionContractState, _isValidating: boolean): ITrialInstitutionContractState {
    const newState: ITrialInstitutionContractState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: ITrialInstitutionContractState,
    formData: Dtos.TrialInstitutionContract | Dtos.TrialInstitutionContract[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionContractState {
    const newState: ITrialInstitutionContractState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: ITrialInstitutionContractState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionContractState {
    const newState: ITrialInstitutionContractState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: ITrialInstitutionContractState, _isCreating: boolean): ITrialInstitutionContractState {
    const newState: ITrialInstitutionContractState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: ITrialInstitutionContractState,
    formData: Dtos.TrialInstitutionContract,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): ITrialInstitutionContractState {
    const newState: ITrialInstitutionContractState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: ITrialInstitutionContractState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionContractState {
    const newState: ITrialInstitutionContractState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function deleting(state: ITrialInstitutionContractState, _isDeleting: boolean): ITrialInstitutionContractState {
    const newState: ITrialInstitutionContractState = update(state, {
        deleteState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function deleteSuccess(
    state: ITrialInstitutionContractState,
): ITrialInstitutionContractState {
    const newState: ITrialInstitutionContractState = update(state, {
        deleteState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function deleteFailure(state: ITrialInstitutionContractState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionContractState {
    const newState: ITrialInstitutionContractState = update(state, {
        deleteState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

const TrialInstitutionContractReducer: Reducer<ITrialInstitutionContractState> = (state: ITrialInstitutionContractState = initialState, action: TrialInstitutionContractAction) => {
    switch (action.type) {
        case ACTION_TRIALINSTITUTIONCONTRACT_LOAD_BY_TRIAL_INSTITUTION_ID:
        case ACTION_TRIALINSTITUTIONCONTRACT_LOAD_BY_ID:
            return loading(state, true);
        case ACTION_TRIALINSTITUTIONCONTRACT_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_TRIALINSTITUTIONCONTRACT_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONCONTRACT_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_TRIALINSTITUTIONCONTRACT_SAVE:
            return saving(state, true);
        case ACTION_TRIALINSTITUTIONCONTRACT_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALINSTITUTIONCONTRACT_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONCONTRACT_VALIDATE:
            return validating(state, true);
        case ACTION_TRIALINSTITUTIONCONTRACT_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALINSTITUTIONCONTRACT_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONCONTRACT_CREATE:
            return creating(state, true);
        case ACTION_TRIALINSTITUTIONCONTRACT_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_TRIALINSTITUTIONCONTRACT_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONCONTRACT_DELETE:
            return deleting(state, true);
        case ACTION_TRIALINSTITUTIONCONTRACT_DELETE_SUCCESS:
            return deleteSuccess(state);
        case ACTION_TRIALINSTITUTIONCONTRACT_DELETE_FAILURE:
            return deleteFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONCONTRACT_FILTER:
            return filter(state, action.formFilter);

    }

    return state;
}

export default TrialInstitutionContractReducer;